import {Variables} from 'graphql-request';

import {OxygenError} from '../types.js';

export const DeploymentCompleteQuery = `
  mutation DeploymentComplete($deploymentId: ID!, $generateAuthBypassToken: Boolean, $authBypassTokenDuration: Int, $environmentVariables: [EnvironmentVariableInput!]) {
    deploymentComplete(id: $deploymentId, generateAuthBypassToken: $generateAuthBypassToken, authBypassTokenDuration: $authBypassTokenDuration, environmentVariables: $environmentVariables) {
      deployment {
        id
        url
      }
      authBypassToken
      userErrors {
        message
      }
    }
  }
`;

export interface DeploymentCompleteQueryData {
  deploymentComplete: DeploymentCompleteResponse;
}

interface EnvironmentVariable {
  isSecret: boolean;
  key: string;
  value: string;
}

export interface DeploymentCompleteQueryVariables extends Variables {
  deploymentId: string;
  generateAuthBypassToken: boolean;
  authBypassTokenDuration?: number;
  environmentVariables?: EnvironmentVariable[];
  [key: string]: string | number | boolean | EnvironmentVariable[] | undefined;
}

export interface DeploymentCompleteResponse {
  deployment: Deployment;
  authBypassToken: string | null;
  userErrors: OxygenError[];
}

interface Deployment {
  id: string;
  url: string;
}
